

import React, { useState, useEffect } from "react";
import { Button, Table, Form, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "app/components/Breadcrumb";
import './notificationcss/Notification.css';
import useTranslations, { getDisplayByEnumKey } from '../transalation/TranslationUtils';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getPushsByPage, pushStatusMap, searchPushsByPage } from "app/redux/slices/rdxPushSlice";
import { cmnFormatDate } from "app/utils/utils";
import { DEFAULT_IP } from "app/utils/constant";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import axios from 'axios';

const Notification = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { role_next, role_previous, pushtiitle, pushnotiification, pushstatus, date, to, approvedby, usersearch,
    createdate, createmsg, func_t, pushdate, editby, lastupdate, pushreset, nonotification, showErrMsg, i18nObj,
    i18nObj2, details,
    draft, scheduled, sent, cancelled,
    loadMore, startEndDateHint, copyPushConfirm, reminder,
    cancel, confirm, copy
  } = useTranslations();

  const translations = useTranslations();

  const pushStatusEnumList = [
    { id: 0, val: draft() },
    { id: 1, val: scheduled() },
    { id: 2, val: sent() },
    { id: 3, val: cancelled() }
  ];

  const [searchParams, setSearchParams] = useState({
    title: "",
    status: -1,
    startDate: "",
    endDate: "",
    approvedBy: ""
  });

  const [prevParams, setPrevParams] = useState({
    title: "",
    status: -1,
    startDate: "",
    endDate: "",
    approvedBy: ""
  });

  const [page, setPage] = useState(0);
  const [hasLoadMore, setHasLoadMore] = useState(false);
  const [pushList, setPushList] = useState([]);
  const [copyPushId, setCopyPushId] = useState(false);

  const users = useSelector((state) => state.rdxMain?.adminList || {});
  const permissions = useSelector((state) => state.rdxMain?.pagePermissions?.account || {});

  useEffect(() => {
    if (searchParams) {
      if (searchParams.title != prevParams.title ||
        searchParams.status != prevParams.status ||
        searchParams.startDate != prevParams.startDate ||
        searchParams.endDate != prevParams.endDate ||
        searchParams.approvedBy != prevParams.approvedBy) {
        setHasLoadMore(false);
      } else if (!searchParams.title &&
        searchParams.status == -1 &&
        !searchParams.startDate &&
        !searchParams.endDate &&
        !searchParams.approvedBy) {
        //reset search and page init search here
        handleSearch(false);
      }
    }
  }, [searchParams]);

  const handleCreateNotification = () => {
    navigate("/pushnotification/mainpage");
  };

  const handleSearch = (hasNext) => {
    let isSearchMode = true;
    if (!searchParams.title &&
      searchParams.status == -1 &&
      !searchParams.startDate &&
      !searchParams.endDate &&
      !searchParams.approvedBy) {
      isSearchMode = false;
    }

    let mPage = 1;
    if (!hasNext) {
      setPrevParams(searchParams);
      setPage(mPage);
    } else {
      mPage = page + 1;
      setPage(mPage);
    }

    let callback = (isSuccess, data) => {
      if (isSuccess) {
        if (mPage > 1) {
          console.log("more");
          if (!data.data || !Array.isArray(data.data) || data.data.length == 0) {
            setHasLoadMore(false);
          } else {
            setHasLoadMore(true);
            const newList = [...pushList];
            data.data.forEach((item) => {
              newList.push(item);
            })
            setPushList(newList);
          }
        } else {
          console.log("first");
          if (!data.data || !Array.isArray(data.data) || data.data.length == 0) {
            setHasLoadMore(false);
          } else {
            setHasLoadMore(true);
          }

          if (Array.isArray(data.data)) {
            setPushList(data.data);
          } else {
            setPushList([]);
          }
        }
      } else {
        let revertPage = mPage - 1;
        if (revertPage < 1) {
          revertPage = 1;
        }
        setPage(revertPage);
        alert(showErrMsg(data));
      }
    }

    if (isSearchMode) {
      if ((searchParams.startDate && !searchParams.endDate) ||
        (!searchParams.startDate && searchParams.endDate)) {
        alert(startEndDateHint());
        return;
      }

      let sendData = {}

      if (searchParams.title) {
        sendData["title"] = searchParams.title;
      }
      if (searchParams.status && "-1" != searchParams.status) {
        sendData["push_status"] = parseInt(searchParams.status);
      }
      if (searchParams.startDate && searchParams.endDate) {
        sendData["start_date"] = convertToTimestamp(searchParams.startDate) / 1000;
        sendData["end_date"] = convertToTimestamp(searchParams.endDate) / 1000;
      }

      if (searchParams.approvedBy) {
        sendData["approval_by"] = searchParams.approvedBy;
      }

      dispatch(searchPushsByPage(mPage, sendData, callback));
    } else {
      dispatch(getPushsByPage(mPage, callback));
    }
  };

  const handleReset = () => {
    setSearchParams({
      title: "",
      status: -1,
      startDate: "",
      endDate: "",
      approvedBy: ""
    });

    setPrevParams({
      title: "",
      status: -1,
      startDate: "",
      endDate: "",
      approvedBy: ""
    });

    //trigger reset search in searchParams's useEffect
  };

  const convertToTimestamp = (dateStr) => {
    let gmt8DateStr = dateStr + "T00:00:00+08:00";
    return (gmt8DateStr ? new Date(gmt8DateStr).getTime() : null)
  };

  const getAfterMonthsDateStr = (baseDateStr, count) => {
    if (!baseDateStr) {
      return "";
    }

    const baseDate = new Date(baseDateStr);

    baseDate.setMonth(baseDate.getMonth() + count);

    const year = baseDate.getFullYear();
    const month = String(baseDate.getMonth() + 1).padStart(2, '0');
    const day = String(baseDate.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  const proceedCopyPush = async () => {
    const postRes = await axios.post(DEFAULT_IP + "/webapp/memportal/copypushtemplate", {
      push_id: copyPushId
    });
    let data = postRes.data;

    if (1 == data?.code) {
      setCopyPushId("");
      navigate("/pushnotification/mainpage?push_id=" + data.data?.push_id);
    } else {
      alert(showErrMsg(data));
    }
  }

  return (
    <div className="container-fluid mt-4">
      <div className="breadcrumb">
        <Breadcrumb routeSegments={[{ name: pushnotiification() }]} />
      </div>
      <Form className="p-3 m-3 border rounded shadow-custom">
        <Row>
          <Col>
            <div className="d-flex flex-wrap">
              <div className="d-flex flex-grow-1 align-items-center me-3">
                <Form.Label className="me-2 mb-0 notificationinputname" style={{ whiteSpace: 'nowrap' }}>{pushtiitle()} :</Form.Label>
                <Form.Control
                  type="text"
                  placeholder=""
                  className="notificationinput"
                  value={searchParams.title}
                  onChange={(e) => setSearchParams({ ...searchParams, title: e.target.value })}
                />
              </div>
              <div className="d-flex flex-grow-1 align-items-center me-3">
                <Form.Label className="me-2 mb-0 notificationinputname" style={{ whiteSpace: 'nowrap' }}>{pushstatus()}:</Form.Label>
                <Form.Group controlId="status" className="d-flex align-items-center w-100 notificationinput">
                  <Form.Select
                    style={{ width: '100%' }}
                    value={searchParams.status}
                    onChange={(e) => setSearchParams({ ...searchParams, status: e.target.value })}
                  >
                    <option value={-1}></option>
                    {pushStatusEnumList.map((item, idx) => (
                      <option key={item.id || idx} value={item.id}>
                        {item.val}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
              <div className="d-flex flex-grow-1 align-items-center me-3">
                <Form.Label className="me-2 mb-0 notificationinputname" style={{ whiteSpace: 'nowrap' }}> {date()} :</Form.Label>
                <Form.Control
                  type="date"
                  value={searchParams.startDate}
                  onChange={(e) => setSearchParams({ ...searchParams, startDate: e.target.value })}
                  {...(searchParams.endDate && { min: getAfterMonthsDateStr(searchParams.endDate, -3), max: getAfterMonthsDateStr(searchParams.endDate, 0) })}
                />
              </div>
              <div className="d-flex flex-grow-1 align-items-center me-3">
                <Form.Label className="me-2 mb-0 notificationinputname" style={{ whiteSpace: 'nowrap' }}> {to()} :</Form.Label>
                <Form.Control
                  type="date"
                  value={searchParams.endDate}
                  onChange={(e) => setSearchParams({ ...searchParams, endDate: e.target.value })}
                  {...(searchParams.startDate && { min: getAfterMonthsDateStr(searchParams.startDate, 0), max: getAfterMonthsDateStr(searchParams.startDate, 3) })}
                />
              </div>
              <div className="d-flex flex-grow-1 align-items-center">
                <Form.Label className="me-2 mb-0 notificationinputname" style={{ whiteSpace: 'nowrap' }}>{approvedby()}:</Form.Label>
                <Form.Group controlId="approvedBy" className="d-flex align-items-center w-100">
                  <Form.Select
                    style={{ width: '100%' }}
                    value={searchParams.approvedBy}
                    onChange={(e) => setSearchParams({ ...searchParams, approvedBy: e.target.value })}
                  >
                    <option value=""></option>

                    {users.map((item) => (
                      <option key={item.admin_id} value={item.admin_id}>
                        {typeof item.admin_name === 'string' ? item.admin_name : item.admin_name?.zh || item.admin_name?.en || 'Unknown'}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <Button variant="success" className="custom-success-btn me-2" onClick={() => { handleSearch(false) }}>{usersearch()}</Button>
            <Button variant="success" className="custom-success-btn me-2" onClick={handleReset}>{pushreset()}</Button>
          </Col>
          <Col className='text-end'>
            {permissions.add && (
              <Button onClick={handleCreateNotification} variant="success" className="custom-success-btn me-2" style={{ width: '178px' }}>{createmsg()}</Button>
            )}
          </Col>
        </Row>
      </Form>

      <div className="table-responsive">
        <Table striped hover className="ms-3 mt-5 me-5">
          <thead>
            <tr>
              <th className="custom-th">{createdate()}</th>
              <th className="custom-th">{pushtiitle()}</th>
              <th className="custom-th">{pushstatus()}</th>
              <th className="custom-th">{pushdate()}</th>
              <th className="custom-th">{editby()}</th>
              <th className="custom-th">{approvedby()}</th>
              <th className="custom-th">{lastupdate()}</th>
              <th className="custom-th">{func_t()}</th>
            </tr>
          </thead>
          <tbody>
            {pushList.length > 0 ? (
              pushList.map((notification, index) => (
                <tr key={index}>
                  <td className="custom-td">{cmnFormatDate(notification.created_date)}</td>
                  <td className="custom-td">{i18nObj2(notification, "title")}</td>
                  <td className="custom-td">{getDisplayByEnumKey(translations, pushStatusMap, notification.push_status)}</td>
                  <td className="custom-td">{cmnFormatDate(notification.push_date)}</td>
                  <td className="custom-td">{typeof notification.updated_by === 'string' ? notification.updated_by : notification.updated_by?.admin_name?.zh || notification.updated_by?.admin_name?.en || notification.updated_by?.admin_name || 'Unknown'}</td>
                  <td className="custom-td">{typeof notification.approval_by === 'string' ? notification.approval_by : notification.approval_by?.admin_name?.zh || notification.approval_by?.admin_name?.en || notification.approval_by?.admin_name || 'Unknown'}</td>
                  <td className="custom-td">{cmnFormatDate(notification.updated_date)}</td>
                  <td>
                    {/* <Button variant="success" className="me-2 customnotificationbtn">Copy and create new message</Button> */}
                    <Button variant="success" className="customnotificationbtn ms-1 me-1 mt-1 mb-1"
                      onClick={() => {
                        navigate("/pushnotification/mainpage?push_id=" + notification.push_id);
                      }}>{details()}</Button>
                    <Button variant="success" className="customnotificationbtn ms-1 me-1 mt-1 mb-1" onClick={() => setCopyPushId(notification.push_id)}>{copy()}</Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">{nonotification()}</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {hasLoadMore && (<div className="mt-3 d-flex justify-content-center">
        <Button variant="outline-success"
          className="custom-outline-success" onClick={() => handleSearch(true)}>{loadMore()}</Button>
      </div>)}
      <div className="mb-5"></div>

      <Dialog
        open={(copyPushId) ? true : false}
        onClose={() => { setCopyPushId(""); }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{reminder()}</DialogTitle>
        <DialogContent>
          <DialogContentText>{copyPushConfirm()}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <button className="btn btn-outline-secondary no-hover" onClick={() => { setCopyPushId(""); }}>{cancel()}</button>
          <Button variant="primary" onClick={proceedCopyPush}>{confirm()}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Notification;
